import React from 'react';
import './Footer.css';
import { NavLink } from 'react-router-dom';

class Footer extends React.Component {
  render() {
    return (
      <footer id="footer" className="footer">
        <div className="footer-bottom">
          <div className="container">
            <div className="flex-container">
              <div className="flex-item">
                <h1 className="footer-title"><a href="https://itgid.info">2019 &copy; React. Lite Level</a></h1>
                <p> All Rights Reserved</p>

              </div>{/*<!-- /.module-body --> */}
              <div className="flex-item">
                <div className="module-body">
                  <ul className="list-unstyled">
                    <li><a href="/sitemap/" tooltip="Карта сайта">Карта сайта</a></li>
                    <li><a href="/sitemaps.xml" target="_blank" tooltip="Google Sitemap">Google Sitemap</a>
                    </li>
                  </ul>
                </div>{/*<!-- /.module-body --> */}
              </div>{/*<!-- /.col -->*/}
              <div className="flex-item">
                <div className="module-body">
                  <ul className="list-unstyled">

                    <li><NavLink to={this.props.link['contacts']} tooltip="Контакты">Контакты</NavLink></li>
                    <li><NavLink to={this.props.link['main']}>Гарантии</NavLink></li>
                    <li><NavLink to={this.props.link['about']}>О сервисе</NavLink></li>
                    <li><NavLink to={this.props.link['main']}>Условия возврата</NavLink></li>
                    <li><NavLink to={this.props.link['main']}>Соглашение о использовании сервиса</NavLink></li>
                  </ul>
                </div>{/*<!-- /.module-body -->*/}
              </div>{/*<!-- /.col -->*/}
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
